/* ============
 * Team Transformer
 * ============
 *
 * The transformer for the team
 */

import Transformer from './transformer'
import teamTransformer from './team'

export default class teamsTransformer extends Transformer {
  /**
   * Method used to transform a fetched team
   *
   * @param team The fetched team
   *
   * @returns {Object} The transformed team
   */
  static fetch (teams) {
    let teamsParsed = []

    teams.forEach(team => {
      team = teamTransformer.fetch(team)
      teamsParsed.push(team)
    })
    return teamsParsed
  }
}
